import { combineReducers, configureStore } from '@reduxjs/toolkit';
import mainPage from 'store/reducers/mainPage';
import measurements from 'store/reducers/measurements';
import layers from 'store/reducers/layers';
import tables from 'store/reducers/tables';
import pieData from 'store/reducers/pieData';
import diagrams from 'store/reducers/diagrams';
import searchTab from 'store/reducers/searchTab';
import feedback from 'store/reducers/feedback';
import dynamicSeries from 'store/reducers/dynamicSeries';
import vectorLayers from 'store/reducers/vectorLayers';
import map from 'store/reducers/map';
import transitData from 'store/reducers/transitData';

const rootReducer = combineReducers({
  diagrams,
  dynamicSeries,
  feedback,
  layers,
  mainPage,
  map,
  measurements,
  pieData,
  tables,
  searchTab,
  transitData,
  vectorLayers,
});

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
